export type Guid = string;
